import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useWebPresentationModeContext } from '@src/config/webPresentationMode'
import { MobileAppFeature } from '@src/types'
import { Debug } from '@src/config'
import { User } from '@src/utils'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { UserAvatar } from './Avatar/UserAvatar'

export const AccountAvatar = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation()

  const { isWebPresentationMode } = useWebPresentationModeContext()

  const adminSettingsEnabled =
    Debug.useAdminMenu && User.hasFeature(MobileAppFeature.AdminAccess) && !isWebPresentationMode

  useLazyScreenPreload('AdminSettings', { shouldPreload: adminSettingsEnabled })

  if (isWebPresentationMode) {
    return null
  }

  const handleAccountIconPress = () => {
    navigation.navigate('Account')
  }

  const handleAccountIconLongPress = () => {
    if (adminSettingsEnabled) {
      navigation.navigate('AdminSettings')
    }
  }

  return (
    <TouchableOpacity
      onPress={handleAccountIconPress}
      onLongPress={handleAccountIconLongPress}
      accessibilityLabel="View account"
    >
      <View style={styles.container}>
        <UserAvatar />
      </View>
    </TouchableOpacity>
  )
}

const themedStyle = StyleService.create({
  container: {
    width: 40,
    height: 40,
    marginHorizontal: 16,
  },
})
